import { getIntrospectionQuery } from 'graphql/utilities';

export const voyagerIntrospectionQuery: string = getIntrospectionQuery();
